import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useScrollToTop } from "../../hooks/useScrollToTop";
import useLayoutStore from "../../store/layout.store";
import MCILogoIcon from "../icons/Logo";
import { twMerge } from "tailwind-merge";

const MainLayout = () => {
  const showLogoInHeader = useLayoutStore((state) => state.showLogoInHeader);

  const location = useLocation();

  useScrollToTop();

  useEffect(() => {
    document.title = "همراه اول";
  }, []);

  return (
    <main
      dir="rtl"
      className="h-screen w-screen relative font-sans bg-repeat text-white"
      style={
        location.pathname !== "/vote/song"
          ? {
              backgroundImage:
                location.pathname?.includes("/song") ||
                location.pathname === "/wheel" ||
                location.pathname === "/otp-activation"
                  ? "url('/images/main-bg2.webp')"
                  : "url('/images/background.png')",
            }
          : {}
      }
    >
      {!location.pathname?.includes("/song") && location.pathname !== "/wheel" ? (
        <div
          className="absolute inset-0 bg-contain bg-no-repeat bg-center z-10"
          style={{
            backgroundImage: "url('/images/white-bg.webp')",
          }}
        />
      ) : null}

      {showLogoInHeader ? (
        <>
          <div
            className={twMerge(
              "absolute top-4 right-4",
              location.pathname !== "/wheel" && "z-[999]"
            )}
          >
            <MCILogoIcon className="h-20 w-20" color="#fff" />
          </div>

          {location.pathname !== "/vote/song" ? (
            <div className="absolute top-6 left-6">
              <img
                src="/images/logo2.svg"
                alt="elecamp"
                className={twMerge(
                  "h-10 md:h-14",
                  location.pathname !== "/wheel" && "z-[999]"
                )}
              />
            </div>
          ) : null}
        </>
      ) : null}

      <div className="relative z-[10] h-full w-full flex justify-center items-center">
        <Outlet />
      </div>
    </main>
  );
};

export default MainLayout;
